import React from 'react';
export function Footer() {
  return <footer className="w-full bg-warm-darker py-10 border-t border-warm-border" data-id="element-79">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-80">
        <p className="font-body text-warm-gray text-sm" data-id="element-81">
          © {new Date().getFullYear()} La Importancia de Levantar tu Autoestima
          en Épocas de Crisis. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}